import { useEffect, useState } from 'react';
import { useOnceGtm } from 'src/features/analytics/hooks/useGtm';
import { Product } from 'src/components/ProductDetail/utils/product-detail.types';
import { ProductPrice } from 'src/types/global-types';
import { v4 as uuidv4 } from 'uuid';
import { sendFbConversionEvent } from 'src/features/analytics/utils/sendFbConversionEvent';
import Bugsnag from '@bugsnag/js';

export function useProductDetailGtm(product: Product, price: ProductPrice, url) {
    const [eventId] = useState(() => uuidv4());

    useEffect(() => {
        sendFbConversionEvent({
            data: [
                {
                    event_name: 'ViewContent',
                    event_time: Math.floor(Date.now() / 1000),
                    action_source: 'website',
                    event_id: eventId,
                    event_source_url: url,
                    user_data: {
                        external_id: [eventId],
                    },
                    custom_data: {
                        contents: [{ id: product.sku }],
                        value: price.price_incl,
                        content_type: 'product',
                    },
                },
            ],
        }).catch((error) => {
            Bugsnag.notify(error);
        });
    }, [eventId, product.sku, price.price_incl, url]);

    useOnceGtm({
        event: 'eec.detail',
        eecEventName: 'Product Detail View',
        ecommerce: {
            detail: {
                eventId: eventId,
                actionField: {
                    list: '', // 'fall collection' // This should be empty if the page is just a single product detail page and not a list like search results or collections
                },
                products: [
                    {
                        id: product.sku,
                        name: product.name,
                        price: price.price_incl,
                    },
                ],
            },
        },
    });
}
